"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { IcoTopButton } from "@/shared/assets/icons/ico_top_button";

interface ScrollToTopButtonProps {
  scrollThreshold?: number;
  className?: string;
}

export function ScrollToTopButton({ scrollThreshold = 300, className = "" }: ScrollToTopButtonProps) {
  const [isVisible, setIsVisible] = useState(false);
  const pathname = usePathname();

  // 메인페이지에서만 표시
  const isMainPage = pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      // 페이지 최하단 근처에 도달했는지 확인
      const scrolled = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      const scrollableHeight = documentHeight - windowHeight;
      const isNearBottom = scrolled >= scrollableHeight - 100; // 하단 100px 전부터 표시

      setIsVisible(isNearBottom);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollThreshold]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!isMainPage || !isVisible) {
    return null;
  }

  return (
    <button
      onClick={scrollToTop}
      className={`pc:right-[114px] pc:bottom-[121px] tb:right-[74px] tb:bottom-[140px] tb:size-13 fixed right-[37px] bottom-[183px] z-50 flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-white transition-all duration-300 ${className}`}
      aria-label="Scroll to top"
    >
      <IcoTopButton />
    </button>
  );
}
